import React from 'react';

import {properties, users} from '../seed/data';

import ApplicantItem from '../components/applicant_item';
import Placeholder from '../components/placeholder';

class UserPropertyEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: [],
            isSent: false
        }
    }

    selectUser (userId) {
        let s = this.state.selected
        if (s.indexOf(userId) < 0) {
            s.push(userId)
            this.setState({
                selected: s 
            })
        } else {
            this.setState({
                selected: s.filter(e => e != userId) 
            })
        }
    }
    onClickSend () {
        this.setState({isSent: true})
    }
    renderSelectedUsers () {
        let s = this.state.selected
        let lst = s.map(id => users.filter(u => u.id == id)[0]);
        return lst.map((u, i) => <ApplicantItem user={u} key={i} selectUser={this.selectUser.bind(this)} selected/>)
    }
    renderUnselectedUsers () {
        let s = this.state.selected
        let lst = users.filter(u => s.indexOf(u.id) < 0);
        return lst.map((u, i) => <ApplicantItem user={u} key={i} selectUser={this.selectUser.bind(this)} 
            selected={this.state.selected.indexOf(u.id) >= 0}/>)
                            
    }

    render () {
        let n = this.props.match.params.pid;
        let p = n <= properties.length ? properties[n] : properties[0];
        return (
            <div className="container frame">
            {/* SYSTEM MESSAGE */}
            {this.state.isSent ? (
              <div className="alert alert-success" role="alert">
                You have replied applicants!
              </div>
            ) : null}
            <h4>{p.address}</h4>
            <br/>
            <div className="row">
                <div className="col-md-3">
                    <div className="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                    <a className="nav-link active" id="v-pills-applicants-tab" 
                        data-toggle="pill" href="#v-pills-applicants" role="tab" 
                        aria-controls="v-pills-applicants" aria-selected="true">Applicants</a>
                    <a className="nav-link" id="v-pills-edit-tab" 
                        data-toggle="pill" href="#v-pills-edit" role="tab" 
                        aria-controls="v-pills-edit" aria-selected="false">Edit Property</a>
                    
                    </div>
                </div>
                <div className="col-md-9">
                    <div className="tab-content" id="v-pills-tabContent">
                        {/* APPLICANTS */}
                        <div className="tab-pane fade show active" id="v-pills-applicants" 
                            role="tabpanel" aria-labelledby="v-pills-applicants-tab">    
                            <h5 className="app-section-title">Selected Applicants</h5>
                                {this.state.selected.length == 0 ? 
                                    <Placeholder message="No applicant selected" /> : 
                                    <div className="app-list-selected">
                                        {this.renderSelectedUsers()}
                                    </div>}
                                {this.state.selected.length > 0 ?
                                    <button className="btn btn-primary btn-app-list" onClick={this.onClickSend.bind(this)}>Send messages</button> : null}
                            <h5 className="app-section-title">Applicants</h5>
                            <div className="app-list">
                                {/* {users.map((u, i) => <ApplicantItem user={u} key={i} selectUser={this.selectUser.bind(this)} selected={this.state.selected.indexOf(u.id) >= 0}/>)} */}
                                {this.state.selected.length < users.length ? this.renderUnselectedUsers() : <Placeholder message="No applicants" />}
                            </div>
                        </div>
                        {/* EDIT FORM */}
                        <div className="tab-pane fade" id="v-pills-edit" 
                            role="tabpanel" aria-labelledby="v-pills-edit-tab">
                            <form>
                                <div className="form-group">
                                    <label htmlFor="inputAddress">Address</label>
                                    <input type="text" className="form-control" id="inputAddress" placeholder="1234 Main St"/>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="inputAddress2">Address 2</label>
                                    <input type="text" className="form-control" id="inputAddress2" placeholder="Apartment, studio, or floor"/>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-md-6">
                                    <label htmlFor="inputCity">City</label>
                                    <input type="text" className="form-control" id="inputCity"/>
                                    </div>
                                    <div className="form-group col-md-4">
                                    <label htmlFor="inputState">State</label>
                                    <select id="inputState" className="form-control">
                                        <option selected>Choose...</option>
                                        <option>...</option>
                                    </select>
                                    </div>
                                    <div className="form-group col-md-2">
                                    <label htmlFor="inputZip">Zip</label>
                                    <input type="text" className="form-control" id="inputZip"/>
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-md-6">
                                    <label htmlFor="inputPrice">Price</label>
                                    <input type="text" className="form-control" id="inputPrice"/>
                                    </div>
                                    <div className="form-group col-md-4">
                                    <label htmlFor="inputRoom">Rooms available</label>
                                        <input type="text" className="form-control" id="inputRoom"/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="form-check">
                                    <input className="form-check-input" type="checkbox" id="gridCheck"/>
                                    <label className="form-check-label" htmlFor="gridCheck">
                                        Check me out
                                    </label>
                                    </div>
                                </div>
                                <button type="submit" className="btn btn-primary">Save</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            
            </div>
        )
    }
}

export default UserPropertyEdit;